var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.1 1c4.467 0 8.1 3.634 8.1 8.1 0 4.467-3.633 8.1-8.1 8.1-4.466 0-8.1-3.633-8.1-8.1C1 4.634 4.634 1 9.1 1zm0 1.2c-3.805 0-6.9 3.095-6.9 6.9S5.295 16 9.1 16 16 12.905 16 9.1s-3.095-6.9-6.9-6.9zm0 9.3c.552 0 1 .447 1 1 0 .553-.448 1-1 1s-1-.447-1-1c0-.553.448-1 1-1zm.315-6.742c.443 0 .8.359.8.8 0 .027 0 .054-.004.08L9.787 9.86c-.03.306-.289.54-.596.54H9.01c-.307 0-.566-.234-.596-.54l-.425-4.221c-.044-.44.277-.833.716-.877.027-.002.053-.003.081-.003h.63z"
  })));
}
export default SvgCommonIconNotice;